import { Logout } from "@mui/icons-material";
import { Box, Button, Toolbar, Typography, useMediaQuery } from "@mui/material";
import { logOut, selectCurrentUser } from "features/auth/authSlice";
import React from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const DigitalAgricultureNavbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useAuth();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = (e) => {
    e.preventDefault();
    handleMenuClose();

    localStorage.removeItem("authState");
    localStorage.removeItem("locationStore");
    localStorage.removeItem("districtName");
    localStorage.removeItem("locationList");
    localStorage.removeItem("locationDropdown");
    localStorage.removeItem("reduxState");

    dispatch(logOut());
    auth.removeUser();
    auth.signoutRedirect({ id_token_hint: auth.user.id_token });
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ffff",
        borderBottom: "1px solid #e5e7eb",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box sx={{ display: "flex", flex: 1, alignItems: "center" }}>
          <img
            src="/assets/img/LC-logo.png"
            alt="Logo"
            style={{
              height: isMobile ? "32px" : "40px",
              cursor: "pointer",
            }}
            onClick={() => navigate("/mis-dashboard")}
          />
        </Box>

        {!isMobile && (
          <Box
            sx={{
              display: "flex",
              flex: 2,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                textAlign: "center",
              }}
            >
              Digital Agriculture - GT Dashboard
            </Typography>{" "}
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            gap: 3,
            justifyContent: "right",
          }}
        >
          <img
            src="/assets/img/digital-1.png"
            alt="img1"
            style={{
              height: isMobile ? "32px" : "40px",
              cursor: "pointer",
            }}
          />
          <img
            src="/assets/img/digital-2.png"
            alt="img"
            style={{
              height: isMobile ? "32px" : "40px",
              cursor: "pointer",
            }}
          />

          <Button
            onClick={handleLogout}
            variant="outlined"
            color="error"
            size="small"
            sx={{
              minWidth: "auto",
              p: 0.5,
              borderRadius: 1.5,
              "&:hover": {
                backgroundColor: "#f44336",
                color: "#fff",
                borderColor: "#f44336",
              },
            }}
          >
            <Logout fontSize="small" />
          </Button>
        </Box>
      </Toolbar>
    </Box>
  );
};

export default DigitalAgricultureNavbar;
